export function getUserCountForSchool(schoolUuid, users) {
  if (!users || !Array.isArray(users)) return 0
  return users.filter(user => {
    if (user.schools && Array.isArray(user.schools)) {
      return user.schools.some(school => school.uuid === schoolUuid)
    }
    return false
  }).length
}

export function validateMergeSelection(sourceSchool, targetSchool) {
  const errors = []
  
  if (!sourceSchool) {
    errors.push('Please select a school to remove')
  }
  
  if (!targetSchool) {
    errors.push('Please select a school to keep')
  }
  
  if (sourceSchool && targetSchool && sourceSchool.uuid === targetSchool.uuid) {
    errors.push('Source and target schools must be different')
  }
  
  return {
    isValid: errors.length === 0,
    errors
  }
}

export function formatSchoolOption(school) {
  if (!school) return null;
  return {
    value: school.uuid,
    text: school.name,
    school: school
  }
}
